import 'styled-components/macro';
import React from 'react';
import { useTheme, Typography } from '@harver/shared-ui';

import { ContentCard } from '../../../components/ContentCard';
import { useContent } from '../../../branding/content.context';
import CookieBanner from '../../../components/CookieBanner';

export function SettingDisabled() {
    const theme = useTheme();
    const { interviewSettingDisabled: LANG } = useContent();

    document.title = LANG.title;

    return (
        <>
            <ContentCard note={<span>{LANG.note}</span>}>
                <div
                    css={{
                        textAlign: 'center',
                        margin: `${theme.sizes.xxxLarge} 0`,
                    }}
                >
                    <Typography
                        testId="expired.title"
                        css={{
                            textAlign: 'center',
                            marginBottom: theme.sizes.large,
                        }}
                        variant="h2"
                    >
                        {LANG.title}
                    </Typography>
                    <Typography
                        css={{
                            textAlign: 'center',
                            marginBottom: theme.sizes.small,
                        }}
                        variant="body2"
                    >
                        {LANG.p1}
                    </Typography>
                </div>
                <CookieBanner />
            </ContentCard>
        </>
    );
}
